import React from 'react';
import { components } from 'react-select';

const Input: typeof components.Input = ({ ...rest }) => <components.Input {...rest} />;

export default Input;
